/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlus: {
  name: 'plus';
  data: string;
} = {
  name: 'plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5Z" fill="currentColor"/></svg>`,
};
